module.exports = __webpack_public_path__ + "img/EUR-USD.61729aff.png";